// Widget-invocation page_view.
//
// Source/Medium reports for 2026-06-17 showed 44% of users + 89% of key
// events landing under session source "(not set)" with 0 engagement and
// 100% bounce — the signature of ad-blocked / ITP-affected users whose
// host-page Google Tag is blocked client-side. For that cohort, the
// widget's MP through sgtm.clubchampion.com is the only event surface
// reaching GA4, and our conversion events arrive at GA4 with no
// session-anchoring event, so GA4 strands them under (not set).
//
// Treating "user invokes the widget" as a page_view fixes this. Opening
// the booking modal is a meaningful page-equivalent interaction; emitting
// a page_view at that moment gives GA4 a real session-creation event with
// proper dl / dr / attribution. For users whose host Google Tag did fire,
// this is a second page_view in the session — acceptable trade-off per
// the "widget invocation = page view" framing — and the host's earlier
// page_view still owns session source. For ad-blocked users, this becomes
// the session-creating event and our captured attribution lands as source.
//
// Idempotent: fires at most once per script load.

import { postToSgtm } from './dispatch';

let fired = false;

export function fireWidgetPageView(): void {
  if (typeof window === 'undefined') return;
  if (fired) return;
  fired = true;
  // postToSgtm builds the canonical MP payload — including dl with our
  // attribution injection (utm_* + gclid from sessionStorage / _gcl_aw),
  // dr from document.referrer, and cid/sid from cookies (or synthetic
  // fallback when the host Google Tag was blocked and no cookie exists).
  //
  // Fail safe: main.tsx calls this DURING inline mount and on every trigger
  // click. An analytics emit must never throw into that path — a throw here
  // (e.g. from a partially-populated CC_WIDGET_CONFIG, or any future change
  // to the dispatch chain) would otherwise propagate into init() and abort
  // the widget render. postToSgtm already no-ops when sGTM isn't configured;
  // this wrapper makes "analytics never blocks the widget" structural rather
  // than dependent on every downstream guard staying correct.
  try {
    postToSgtm('page_view', {});
  } catch {
    /* analytics never blocks the widget mount */
  }
}
